import image from 'assets/images/finance/insights/gtm.png'

import i18n from 'modules/core/lib/i18n'

import { UpsellExpensesButton } from 'modules/finance/components/FinancialWorkspace/components/UpsellExpenses'

import { UploadPayrollButton } from '../../components/Buttons/UploadPayroll'
import { Base } from '../base'
import { sections } from './sections'

export const NoPayrollNoExpenses = () => {
  return (
    <Base
      information={{
        motion: {
          url: image,
          alt: i18n.t('finance.financial_workspace.payroll.landing.expenses_sections.title'),
          type: 'image',
        },
        body: {
          title: i18n.t('finance.financial_workspace.payroll.landing.expenses_sections.title'),
          description: i18n.t(
            'finance.financial_workspace.payroll.landing.no_expenses_sections.description'
          ),
          children: (
            <>
              <UpsellExpensesButton />
              <UploadPayrollButton type="outline" />
            </>
          ),
        },
      }}
      sections={sections()}
    />
  )
}
